export const GOOGLE_RECAPTCHA_V3_KEY = "6LeoyeUpAAAAAHTcr0BluRlUgjwd4bJ86VaHTzhu";
